import React from 'react';
import PropTypes from 'prop-types';
import '../../assets/css/home.css';

const AgencyInfo = props => (
    <div className="row">
        <div className="col-md-6">
            <div className="card">
                <div className="header">
                    <h5 className="">Pri Fund</h5>
                </div>
                <div className="content">
                    <table className="table">
                        <tbody>
                            <tr>
                                <td with="50%">
                                    <strong className="title-float">Disbursed Amount</strong>
                                    <span className="floating-info">{props.helpText.Disbursed_Amount_Pri__c}</span>
                                </td>
                                <td>${props.agencyData.Disbursed_Amount_Pri__c ? props.agencyData.Disbursed_Amount_Pri__c.toLocaleString() : 0}</td>
                            </tr>
                            <tr>
                                <td with="50%">
                                    <strong className="title-float">Available Amount</strong> 
                                    <span className="floating-info">{props.helpText.Available_Amount_Pri__c}</span>
                                </td>
                                <td>${props.agencyData.Available_Amount_Pri__c ? props.agencyData.Available_Amount_Pri__c.toLocaleString() : 0 }</td>
                            </tr>
                            <tr>
                                <td with="50%">
                                    <strong className="title-float">Approved Amount</strong>
                                    <span className="floating-info">{props.helpText.Approved_Amount_Pri__c}</span>
                                </td>
                                <td>${props.agencyData.Approved_Amount_Pri__c ? props.agencyData.Approved_Amount_Pri__c.toLocaleString() : 0 }</td>
                            </tr>
                            <tr>
                                <td with="50%">
                                    <strong className="title-float">Account Balance</strong>
                                    <span className="floating-info">{props.helpText.Account_Balance_Pri__c}</span>
                                </td>
                                <td>${props.agencyData.Account_Balance_Pri__c ? props.agencyData.Account_Balance_Pri__c.toLocaleString() : 0 }</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div className="col-md-6">
            <div className="card ">
                <div className="header">
                    <h5> Sec Fund</h5>
                </div>
                <div className="content">
                    <table className="table">
                        <tbody>
                            <tr>
                                <td with="50%">
                                    <strong className="title-float">Disbursed Amount</strong>
                                    <span className="floating-info">{props.helpText.Disbursed_Amount_Sec__c}</span>
                                </td>
                                <td>${props.agencyData.Disbursed_Amount_Sec__c ? props.agencyData.Disbursed_Amount_Sec__c.toLocaleString() : '0'}</td>
                            </tr>
                            <tr>
                                <td with="50%">
                                    <strong className="title-float">Available Amount</strong>
                                    <span className="floating-info">{props.helpText.Available_amount_Sec__c}</span>
                                </td>
                                <td>${props.agencyData.Available_amount_Sec__c ? props.agencyData.Available_amount_Sec__c.toLocaleString() : 0 }</td>
                            </tr>
                            <tr>
                                <td with="50%">
                                    <strong className="title-float">Approved Amount</strong>
                                    <span className="floating-info">{props.helpText.Approved_Amount_Sec__c}</span>
                                </td>
                                <td>${props.agencyData.Approved_Amount_Sec__c ? props.agencyData.Approved_Amount_Sec__c.toLocaleString() : 0}</td>
                            </tr>
                            <tr>
                                <td with="50%">
                                    <strong className="title-float">Account Balance</strong>
                                    <span className="floating-info">{props.helpText.Account_Balance_Sec__c}</span>
                                </td>
                                <td>${props.agencyData.Account_Balance_Sec__c ? props.agencyData.Account_Balance_Sec__c.toLocaleString() : 0}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div className="col-md-6">
            <div className="card ">
                <div className="header">
                    <h5>Post Sec Fund</h5>
                </div>
                <div className="content">
                    <table className="table">
                        <tbody>
                            <tr>
                                <td with="50%">
                                    <strong className="title-float">Disbursed Amount</strong>
                                    <span className="floating-info">{props.helpText.Disbursed_Amount_Post_Sec__c}</span>
                                </td>
                                <td>${props.agencyData.Disbursed_Amount_Post_Sec__c ? props.agencyData.Disbursed_Amount_Post_Sec__c.toLocaleString() : '0'}</td>
                            </tr>
                            <tr>
                                <td with="50%">
                                    <strong className="title-float">Available Amount</strong>
                                    <span className="floating-info">{props.helpText.Available_Amount_Post_Sec__c}</span>
                                </td>
                                <td>${props.agencyData.Available_Amount_Post_Sec__c ? props.agencyData.Available_Amount_Post_Sec__c.toLocaleString() : 0 }</td>
                            </tr>
                            <tr>
                                <td with="50%">
                                    <strong className="title-float">Approved Amount</strong>
                                    <span className="floating-info">{props.helpText.Approved_Amount_Post_Sec__c}</span>
                                </td>
                                <td>${props.agencyData.Approved_Amount_Post_Sec__c ? props.agencyData.Approved_Amount_Post_Sec__c.toLocaleString() : 0}</td>
                            </tr>
                            <tr>
                                <td with="50%">
                                    <strong className="title-float">Account Balance</strong>
                                    <span className="floating-info">{props.helpText.Account_Balance_Post_Sec__c}</span>
                                </td>
                                <td>${props.agencyData.Account_Balance_Post_Sec__c ? props.agencyData.Account_Balance_Post_Sec__c.toLocaleString() : 0}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div className="col-md-6">
            <div className="card ">
                <div className="header">
                    <h5>Number of Exception</h5>
                </div>
                <div className="content">
                    <table className="table">
                        <tbody>
                            <tr>
                                <td with="50%">
                                    <strong>Max Allowed Exception Beneficiary This Year</strong>
                                </td>
                                <td>{props.data.qtotalExceptions ? props.data.qtotalExceptions.Max_allowed_excp_Bene_this_year__c.toLocaleString() : '-'}</td>
                            </tr>
                            <tr>
                                <td with="50%">
                                    <strong>Total Exception Approved Beneficiary Last Year</strong>
                                </td>
                                <td>{props.data.qtotalExceptions ? props.data.qtotalExceptions.Total_Excp_Bene_Aprved_Last_Year__c : '-'}</td>
                            </tr>
                            <tr>
                                <td with="50%">
                                    <strong>Total Exception Approved Beneficiary This Year</strong>
                                </td>
                                <td>{props.data.qtotalExceptions ? props.data.qtotalExceptions.Total_Excp_Bene_Aprved_This_Year__c : '-'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
);

AgencyInfo.propTypes = {
    data: PropTypes.object.isRequired,
};


export default AgencyInfo;



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/AgencyInfo.js
// module id = 987
// module chunks = 0